export default "__VITE_ASSET__C0rmPMaX__"